import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { RegisterTerminalGenericNavigation } from './navigation/register-terminal-generic-navigation';
import { RegisterTerminalStepNavigationProps } from './register-terminal.types';

export const RegisterTerminalNavigationSwitch = ({ body }: RegisterTerminalStepNavigationProps) => {
  return <StepNavigationSwitch body={body} generic={RegisterTerminalGenericNavigation} />;
};
